export default key => {
  let value = defaults[key];
  if (typeof window !== "undefined") {
    value =
      window.config && window.config[key] !== undefined
        ? window.config[key]
        : defaults[key];
  }
  return value;
};

const defaults = {
  CONSOLE_URL: "https://console.humanitix.net",
  TICKETING_URL: "https://events.humanitix.net",
  HELP_DOCS_URL: "https://humanitix.helpdocs.io",
  ALGOLIA_APP_ID: "VQHD8CBFYJ",
  ALGOLIA_SEARCH_API_KEY: "98752ba18cb832c23167defbfe33d878",
  ALGOLIA_INDEX: "events_aus_staging",
  ZIPMONEY_ENV: "sandbox",
  ZIPMONET_MERCHANT_UNIQUE_ID: "f18b506d-ddf9-4ed0-bdb7-febdf48e6d6d",
  ZIP_WIDGET_SCRIPT:
    "https://static.zipmoney.com.au/lib/js/zm-widget-js/dist/zip-widget.min.js",
  ZIP_JQUERY_SCRIPT: "https://code.jquery.com/jquery-latest.min.js",
  API_URL: "http://localhost:3005/api",
  GOOGLE_API_KEY: "AIzaSyBrLKaAEokK10u3KCRKI0WJyXUN6iAT6AI",
  SEARCH_PREFERENCE_LAT: -34,
  SEARCH_PREFERENCE_LNG: 151,
  HUMANITIX_CONTACT_NUMBER: "02 9986 2635",
  ENV: "Local"
};
